import initSliderCards from '../shared/sliderCards';

const initNotFound = ({ notFound }) => {
  notFound.similar.forEach(({ id, count }) => {
    initSliderCards(id, count);
  });
};

export default initNotFound;
